/**
 * Web Meta Pixel configuration.
 *
 * Event names are aligned cross-platform for reporting.
 */
export const META_PIXEL_ENABLED = true;
export const META_PIXEL_ID = '1868499863595786';

export const META_EVENTS = {
  completeRegistration: 'CompleteRegistration',
  subscribe: 'Subscribe',
  pageView: 'PageView',
} as const;
